export class UnsupportedDeviceError extends Error {
  constructor(unsuportedMethod: string) {
    super(`"${unsuportedMethod}" is not supported on this device.`);
    this.name = 'UnsupportedDeviceError';
  }
}
